import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ReferralHelpNote() {
    return (_jsxs("p", { className: "referral-help-note", children: ["Questions?", ' ', _jsx("a", { href: "mailto:bhreferrals@inspirehealthalliance.com", children: "bhreferrals@inspirehealthalliance.com" }), _jsx("span", { className: "referral-help-note-rest", children: "Please do not email patient information." })] }));
}
